<template>
  <div v-frag>
    <CardIeaAppMain>
      <div v-if="user.tipoUsuario == 'alumno'" style="width: 100%">
        <div v-if="waiting || docsPend > 0">
          <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
            <v-card elevation="0" class="rounded-xl" color="secondaryApp">
              <v-card-title> Documentos Requeridos: </v-card-title>
              <v-card-text>
                <ul class="text--primary">
                  <div
                    v-for="(documento, index) in documentosAlumno"
                    :key="index"
                  >
                    <li v-if="documento.validar == 0">
                      {{ documento.nameDocumento }}
                    </li>
                  </div>
                </ul>
              </v-card-text>
            </v-card>
          </v-col>
        </div>
        <div v-else style="width: 100%">
          <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
            <v-card elevation="0" class="rounded-xl" color="secondaryApp">
              <v-card-title
                style="
                  display: flex;
                  justify-content: center;
                  background-color: rgb(58, 66, 153);
                  color: white;
                "
              >
                Documentación Completa
              </v-card-title>
            </v-card>
          </v-col>
        </div>

        <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
          <v-card elevation="0" class="rounded-xl" color="secondaryApp">
            <v-card-title>
              {{ tituloNovedades }}
            </v-card-title>
            <v-card-text>
              <div class="text--primary">
                {{ descripcionNovedades }}
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" xs="12" sm="12" md="12" xl="12" lg="12">
          <v-alert prominent type="error" v-if="user.borrado == '1'">
            Su usuario esta de baja, para activarlo por favor pague las cuotas
            adeudadas
          </v-alert>
        </v-col>
      </div>

      <!-- <v-row justify="center" align-content="center" align="start"> -->
      <v-col
        cols="6"
        xs="6"
        sm="4"
        md="3"
        xl="2"
        lg="2"
        v-for="(item, index) in menuValidar"
        :key="index"
        align-self="start"
      >
        <CardIeaCategory
          :text="item.text"
          :color="user.borrado == '1' && item.validate ? '#dfdfdf' : item.color"
          :icon="item.icon"
          @press="menuAction(item.route, item.validate)"
        />
      </v-col>
      <!-- </v-row> -->
    </CardIeaAppMain>
    <br />
    <div v-if="user.borrado !== '1'">
      <div v-frag v-for="(item, i) in panels" :key="i">
        <v-card
          :class="
            $vuetify.breakpoint.name == 'xs'
              ? 'rounded-xl pr-4 pl-4'
              : 'rounded-xl pr-8 pl-8'
          "
          color="cardOne"
          v-if="item.id != 0"
          style="margin-bottom: 25px"
        >
          <!-- <v-container :class="$vuetify.breakpoint.name == 'xs' ? '' :'pr-8 pl-8'" fluid> -->
          <v-row
            align="center"
            justify="center"
            align-content="center"
            v-if="user.tipoUsuario == 'alumno'"
          >
            <v-col cols="12" xs="12" sm="12" md="12" xl="12" lg="12">
              <v-row @click="openPanel(item)" no-gutters>
                <v-col
                  cols="9"
                  xs="9"
                  sm="9"
                  md="9"
                  xl="9"
                  lg="9"
                  align-self="center"
                >
                  <div
                    class="
                      text-xs-h5 text-sm-h5 text-md-h5 text-lg-h5 text-xl-h5
                      grey--text
                      text--darken-2
                    "
                  >
                    {{ item.text }}
                  </div>
                </v-col>
                <v-col
                  cols="3"
                  xs="3"
                  sm="3"
                  md="3"
                  xl="3"
                  lg="3"
                  align-self="center"
                  class="d-flex justify-end"
                >
                  <v-avatar
                    color="background"
                    rounded
                    class="rounded-lg"
                    size="45"
                  >
                    <v-icon color="#8fc6dc" x-large v-if="!item.active">
                      mdi-menu-down
                    </v-icon>
                    <v-icon color="#8fc6dc" x-large v-if="item.active">
                      mdi-menu-up
                    </v-icon>
                  </v-avatar>
                </v-col>
              </v-row>
              <v-expand-transition>
                <v-row v-show="item.active" align="center">
                  <v-col cols="12" xs="12" sm="12" md="12" xl="12" lg="12">
                    <!-- class room -->
                    <div v-frag v-if="item.id == 2">
                      <div
                        v-frag
                        v-for="(planDeEstudio, planDeEstudioKey) in item.data"
                        :key="planDeEstudioKey"
                      >
                        <div
                          class="
                            text-xs-h4
                            text-sm-h4
                            text-md-h4
                            text-lg-h4
                            text-xl-h4
                            primary--text
                          "
                        >
                          {{ planDeEstudio.CursoNombre }}
                        </div>
                        <v-simple-table>
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th class="text-left">Plan de estudio</th>
                                <th class="text-left">Código ClassRoom</th>
                                <th class="text-left">ClassRoom (BETA)</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(
                                  planDeEstudioData, planDeEstudioDataKey
                                ) in planDeEstudio.planDeEstudio"
                                :key="planDeEstudioDataKey"
                              >
                                <td>
                                  {{
                                    $vuetify.breakpoint.name == "xs"
                                      ? planDeEstudioData.catedraMin
                                      : planDeEstudioData.catedra
                                  }}
                                </td>
                                <td>{{ planDeEstudioData.codClassRoom }}</td>
                                <td>
                                  <div
                                    v-frag
                                    v-if="planDeEstudioData.link != ''"
                                  >
                                    <v-btn
                                      @click="linkVideo(planDeEstudioData)"
                                      small
                                      class="
                                        info--text
                                        text-decoration-underline
                                        font-weight-regular
                                      "
                                      depressed
                                      text
                                      color="info"
                                      >Ver Aquí</v-btn
                                    >
                                  </div>
                                  <div v-frag v-else>
                                    <b class="text-center">Sin contenido aún</b>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </div>
                    </div>
                    <!-- class room -->
                    <!-- mesa de exames -->
                    <div v-frag v-if="item.id == 1">
                      <v-card elevation="0">
                        <v-card-text
                          >Cantidad de materia disponibles :
                          {{ item.data.cantidad }}</v-card-text
                        >
                      </v-card>
                      <br />
                      <div
                        v-frag
                        v-for="(examenMesa, examenMesaKey) in item.data.data"
                        :key="examenMesaKey"
                      >
                        <div
                          class="
                            text-xs-h4
                            text-sm-h4
                            text-md-h4
                            text-lg-h4
                            text-xl-h4
                            primary--text
                          "
                        >
                          {{ examenMesa.curso.Feriado }}
                        </div>
                        <v-simple-table>
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th class="text-left">Examen</th>
                                <th class="text-center">Acción</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(
                                  planDeEstudioData, planDeEstudioDataKey
                                ) in examenMesa.curso.plan_de_estudio_v2"
                                :key="planDeEstudioDataKey"
                              >
                                <td>{{ planDeEstudioData.Materia }}</td>
                                <td style="text-align: center">
                                  <div
                                    v-frag
                                    v-if="planDeEstudioData.tipo == 0"
                                  >
                                    <v-btn
                                      @click="() => null"
                                      class="grey--text font-weight-regular"
                                      depressed
                                      text
                                      disabled
                                      color="grey"
                                      >Sin Mesa Aún</v-btn
                                    >
                                  </div>
                                  <div
                                    v-frag
                                    v-if="
                                      examenMesa.curso.diasUltimaInscripcion <
                                        365 && planDeEstudioData.tipo == 1
                                    "
                                  >
                                    <v-btn
                                      v-show="item.data.cantidad > 0"
                                      style="border: 1px solid"
                                      @click="
                                        inscripcionMesaExamen(
                                          planDeEstudioData.IDStB,
                                          examenMesa.id
                                        )
                                      "
                                      depressed
                                      text
                                      color="Colorsuccess"
                                      >Inscribir</v-btn
                                    >
                                  </div>
                                  <div
                                    v-frag
                                    v-if="planDeEstudioData.tipo == 2"
                                  >
                                    <v-alert
                                      color="info"
                                      style="
                                        background-color: rgba(
                                          100,
                                          181,
                                          246,
                                          0.2
                                        ) !important;
                                        border: 1px solid;
                                        padding: 5px;
                                        margin-bottom: 5px !important;
                                        margin-top: 5px !important;
                                        padding-left: 0px;
                                        padding-right: 0px;
                                      "
                                    >
                                      Esperando confirmación
                                      <v-btn
                                        @click="
                                          cancelarInscripcionMesaExamen(
                                            planDeEstudioData
                                              .examen_inscipcion_alumno[0]
                                              .id_validacion
                                          )
                                        "
                                        small
                                        class="
                                          red--text
                                          text-decoration-underline
                                          font-weight-regular
                                        "
                                        depressed
                                        text
                                        color="red"
                                        >Cancelar</v-btn
                                      >
                                    </v-alert>
                                  </div>
                                  <div
                                    v-frag
                                    v-if="planDeEstudioData.tipo == 3"
                                  >
                                    <div v-if="planDeEstudioData != null">
                                      <div
                                        v-if="
                                          planDeEstudioData.examen_asociado !=
                                            null &&
                                          planDeEstudioData.examen_asociado
                                            .tipo_link == 0
                                        "
                                      >
                                        <v-btn
                                          @click="
                                            linkPrueba(
                                              planDeEstudioData.examen_asociado
                                                .id_testpyr
                                            )
                                          "
                                          depressed
                                          style="border: 1px solid"
                                          text
                                          color="rgb(143, 198, 220)"
                                        >
                                          Prueba
                                        </v-btn>
                                      </div>

                                      <div
                                        v-else-if="
                                          planDeEstudioData.examen_asociado !=
                                          null
                                        "
                                      >
                                        <v-btn
                                          :href="
                                            planDeEstudioData.examen_asociado
                                              .google_meet_url
                                          "
                                          depressed
                                          target="_blank"
                                          style="
                                            border: 1px solid;
                                            margin-left: 10px;
                                          "
                                          text
                                          color="rgb(219, 29, 74)"
                                        >
                                          ClassRoom
                                        </v-btn>
                                      </div>

                                      <div v-else>
                                        <v-btn
                                          @click="() => null"
                                          depressed
                                          style="border: 1px solid"
                                          text
                                          color="Colorsuccess"
                                        >
                                          Inscripto
                                        </v-btn>
                                      </div>
                                    </div>

                                    <div v-else>
                                      <v-btn
                                        @click="() => null"
                                        class="grey--text font-weight-regular"
                                        depressed
                                        text
                                        disabled
                                        color="grey"
                                      >
                                        Sin Mesa Aún
                                      </v-btn>
                                    </div>
                                  </div>
                                  <div
                                    v-frag
                                    v-if="planDeEstudioData.tipo == 4"
                                  >
                                    <v-alert type="error"> Rechazado </v-alert>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </div>
                      <br /><br />
                    </div>
                    <!-- mesa de exames -->

                    <!-- pagos -->
                    <div v-frag v-if="item.id == 3">
                      <div
                        v-frag
                        v-for="(itemTable, keyTable) in item.data"
                        :key="keyTable"
                      >
                        <div
                          class="
                            text-xs-h4
                            text-sm-h4
                            text-md-h4
                            text-lg-h4
                            text-xl-h4
                            primary--text
                          "
                        >
                          {{ itemTable.nombre }}
                        </div>
                        <v-simple-table>
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th class="text-left">Concepto</th>
                                <th class="text-left">Monto</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(
                                  itemTableData, keyItemTableData
                                ) in itemTable.data"
                                :key="keyItemTableData"
                              >
                                <td>{{ itemTableData.Concepto }}</td>
                                <td>${{ itemTableData.Monto }}</td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </div>
                      <br /><br />
                    </div>
                    <!-- pagos -->

                    <!-- test -->

                    <div v-frag v-if="item.id == 4">
                      <div>
                        <v-simple-table>
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th class="text-left">Nombre del Test</th>
                                <th class="text-left">Descripcion</th>
                                <th class="text-left">Fecha</th>
                                <th class="text-left">Hora</th>
                                <th class="text-left">Test (BETA)</th>
                                <th class="text-center">Link Meet</th>
                              </tr>
                            </thead>
                            <tbody
                              v-frag
                              v-for="(test, keyTable) in item.data"
                              :key="keyTable"
                            >
                              <tr>
                                <td>
                                  {{
                                    $vuetify.breakpoint.name == "xs"
                                      ? test.titulo
                                      : test.titulo
                                  }}
                                </td>
                                <td>
                                  {{
                                    $vuetify.breakpoint.name == "xs"
                                      ? test.descripcion
                                      : test.descripcion
                                  }}
                                </td>
                                <td>
                                  {{
                                    $vuetify.breakpoint.name == "xs"
                                      ? test.fecha_test
                                      : test.fecha_test
                                  }}
                                </td>
                                <td>
                                  {{
                                    $vuetify.breakpoint.name == "xs"
                                      ? test.hora_inicio
                                      : test.hora_inicio
                                  }}
                                </td>
                                <td v-if="test.tipo == 'Practica'">
                                  <div v-frag>
                                    <v-btn
                                      @click="linkTest(test)"
                                      small
                                      class="
                                        info--text
                                        text-decoration-underline
                                        font-weight-regular
                                      "
                                      depressed
                                      text
                                      color="info"
                                      >Presentar Test</v-btn
                                    >
                                  </div>
                                </td>
                                <td v-else-if="test.tipo == 'Examen Final'">
                                  <div
                                    v-frag
                                    v-if="test.testPresentado == false"
                                  >
                                    <v-btn
                                      @click="linkTest(test)"
                                      small
                                      class="
                                        info--text
                                        text-decoration-underline
                                        font-weight-regular
                                      "
                                      depressed
                                      text
                                      color="info"
                                      >Presentar Test</v-btn
                                    >
                                  </div>

                                  <div v-frag v-else>
                                    <v-btn
                                      small
                                      class="
                                        success--text
                                        text-decoration-underline
                                        font-weight-regular
                                      "
                                      depressed
                                      text
                                      color="success"
                                      >Test Finalizado</v-btn
                                    >
                                  </div>
                                </td>

                                <td>
                                  <v-btn
                                    :href="test.url_meet"
                                    small
                                    class="
                                      info--text
                                      text-decoration-underline
                                      font-weight-regular
                                    "
                                    depressed
                                    text
                                    color="info"
                                    >Ver Aquí</v-btn
                                  >
                                </td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </div>
                    </div>

                    <!-- test -->

                    <!-- Materias Faltantes -->

                    <div v-frag v-if="item.id == 5">
                      <v-simple-table>
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th class="text-left">Materia</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(
                                itemTableData, keyItemTableData
                              ) in materiaFaltantes"
                              :key="keyItemTableData"
                            >
                              <td>{{ itemTableData.catedra }}</td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>

                      <br /><br />
                    </div>

                    <!-- Materias Faltantes -->
                  </v-col>
                </v-row>
              </v-expand-transition>
            </v-col>
          </v-row>
          <!-- </v-container> -->
        </v-card>
      </div>
    </div>
    <div v-if="sendvalidation">
      <DialogValidationAlumno />
    </div>
  </div>
</template>
<script>
import CardIeaAppMain from "../components/CardIeaAppMain";
import CardIeaCategory from "../components/CardIeaCategory";
import DialogValidationAlumno from "../components/DialogValidationAlumno";
export default {
  name: "Home",
  components: {
    CardIeaAppMain,
    CardIeaCategory,
    DialogValidationAlumno,
  },
  data: () => ({
    tituloNovedades: "",
    descripcionNovedades: "",
    sendvalidation: false,
    documentosAlumno: [],
    waiting: true,
    docsPend: 0,
    materiaFaltantes: [],
    menu: [
      {
        text: "Chat",
        icon: require("../assets/categories/13.png"),
        color: "#e79024",
        route: "Chat",
        validate: true,
        tipoUsuario: "alumno",
      },
      {
        text: "Publicaciones",
        icon: require("../assets/categories/14.png"),
        color: "#db1d4a",
        route: "Publicacion",
        validate: true,
        tipoUsuario: "alumno",
      },
      {
        text: "Denuncias",
        icon: require("../assets/categories/3.png"),
        color: "#db1d4a",
        route: "Denuncia",
        validate: true,
        tipoUsuario: "alumno",
      },
      {
        text: "Consultas",
        icon: require("../assets/categories/4.png"),
        color: "#a7ba38",
        route: "Consulta",
        validate: false,
        tipoUsuario: "alumno",
      },
      /*
      {
        text: "Turnos presenciales",
        icon: require("../assets/categories/10.png"),
        color: "#db1d4a",
        route: "Turno",
        validate: true,
        tipoUsuario: "all",
      },
      {
        text: "Llamadas",
        icon: require("../assets/categories/11.png"),
        color: "#a7ba38",
        route: "Llamada",
        validate: true,
        tipoUsuario: "all",
      },
      */
      {
        text: "Pagar curso",
        icon: require("../assets/categories/7.png"),
        color: "#3a4299",
        route: "PaymentCurso",
        validate: false,
        tipoUsuario: "alumno",
      },
      {
        text: "Mis materias",
        icon: require("../assets/categories/6.png"),
        color: "#a7ba38",
        route: "MisMaterias",
        validate: true,
        tipoUsuario: "alumno",
      },
      {
        text: "Inscripciones a cursar materias",
        icon: require("../assets/categories/6.png"),
        color: "#e79024",
        route: "Materia",
        validate: true,
        tipoUsuario: "alumno",
      },
      {
        text: "Materias optativas",
        icon: require("../assets/categories/6.png"),
        color: "#8fc6dc",
        route: "Optativa",
        validate: true,
        tipoUsuario: "alumno",
      },
      {
        text: "Nuevo trámite",
        icon: require("../assets/categories/2.png"),
        color: "#e79024",
        route: "Tramite",
        validate: true,
        tipoUsuario: "alumno",
      },
      {
        text: "Documentos faltantes",
        icon: require("../assets/categories/5.png"),
        color: "#8fc6dc",
        route: "Documento",
        validate: true,
        tipoUsuario: "alumno",
      },
      {
        text: "Listado de notas",
        icon: require("../assets/categories/6.png"),
        color: "#8fc6dc",
        route: "Nota",
        validate: true,
        tipoUsuario: "alumno",
      },
      {
        text: "Informar un pago",
        icon: require("../assets/categories/7.png"),
        color: "#3a4299",
        route: "InformarPago",
        validate: false,
        tipoUsuario: "alumno",
      },
      {
        text: "Pagos regulares",
        icon: require("../assets/categories/7.png"),
        color: "#3a4299",
        route: "PaymentRegular",
        validate: false,
        tipoUsuario: "alumno",
      },

      {
        text: "Verificar cuenta",
        icon: require("../assets/categories/1.png"),
        color: "#8fc6dc",
        route: "Verifier",
        validate: true,
        tipoUsuario: "alumno",
      },
       {
        text: "Secretaria Virtual",
        icon: require("../assets/categories/6.png"),
        color: "#db1d4a",
        route: "Secretaria",
        validate: true,
        tipoUsuario: "alumno",
      },
      
      {
        text: "Chat",
        icon: require("../assets/categories/13.png"),
        color: "#e79024",
        route: "ChatProfesor",
        validate: true,
        tipoUsuario: "profesor",
      },
    
      {
        text: "Clases",
        icon: require("../assets/categories/10.png"),
        color: "#3a4299",
        route: "Clases",
        validate: false,
        tipoUsuario: "profesor",
      },
      {
        text: "Test/Materias",
        icon: require("../assets/categories/3.png"),
        color: "#62C542",
        route: "Evaluaciones",
        validate: false,
        tipoUsuario: "profesor",
      },
      {
        text: "Foros",
        icon: require("../assets/categories/15.png"),
        color: "#3a4299",
        route:"Foro",
        validate:true,
        tipoUsuario: "alumno",
      },
      {
        text: "Salir",
        icon: require("../assets/categories/12.png"),
        color: "#a2a2a2",
        route: "Logout",
        validate: false,
        tipoUsuario: "all",
      },
    ],

    panels: [
      {
        id: 0,
        text: "Tus Inscripciones a Materias",
        active: false,
        data: [],
        tipoUsuario: "alumno",
      },
      {
        id: 1,
        text: "Tus Inscripciones a Exámenes",
        active: false,
        data: [],
        tipoUsuario: "alumno",
      },
      {
        id: 2,
        text: "Plan de estudio y classroom",
        active: false,
        data: [],
        tipoUsuario: "alumno",
      },
      {
        id: 3,
        text: "Tus Pagos",
        active: false,
        data: [],
        tipoUsuario: "alumno",
      },
      {
        id: 4,
        text: "Actividades a Realizar",
        active: false,
        data: [],
        tipoUsuario: "alumno",
      },
      {
        id: 5,
        text: "Materias Que Me Faltan",
        active: false,
        data: [],
        tipoUsuario: "alumno",
      },
    ],
  }),
  computed: {
    user() {
      return this.$store.getters.user;
    },
    menuValidar: function () {
      let usuario = this.$store.getters.user;
      return this.menu.filter(function (m) {
        return m.tipoUsuario == usuario.tipoUsuario || m.tipoUsuario == "all";
      });
    },
  },
  mounted() {
    if (this.user.tipoUsuario == "alumno") {
      this.novedadesList();
      this.registerAccess();
      this.documentosRequeridos(this.user.IDStB);
      console.log(this.user.borrado);
    }
  },
  methods: {
    async openPanel(item) {
      if (item.id == 2) {
        if (!item.active) {
          await this.planDeEstudioGet();
        } else {
          // this.panels[2].data = []
        }
      }
      if (item.id == 1) {
        if (!item.active) {
          await this.mesaDeExamen();
        } else {
          // this.panels[1].data = []
        }
      }
      if (item.id == 0) {
        if (!item.active) {
          await this.mesaDeMateria();
        } else {
          // this.panels[1].data = []
        }
      }

      if (item.id == 3) {
        if (!item.active) {
          await this.tuPagos();
        } else {
          // this.panels[1].data = []
        }
      }

      if (item.id == 4) {
        if (!item.active) {
          await this.testPrueba();
        } else {
          // this.panels[1].data = []
        }
      }

      if (item.id == 5) {
        if (!item.active) {
          await this.MateriasFaltan();
        } else {
          // this.panels[1].data = []
        }
      }

      item.active = !item.active;
    },
    async novedadesList() {
      //let that = this;
      await this.$API
        .get({
          url: "notificaciones/index",
          data: {},
        })
        .then((res) => {
          this.tituloNovedades = res[res.length - 1].titulo.toUpperCase();
          this.descripcionNovedades =
            res[res.length - 1].descripcion.toLowerCase();
        });
    },
    async registerAccess() {
      await this.$API
        .post({
          url: "alumno/register-access",
          data: {
            tipo: "web",
          },
        })
        .then((res) => {
          console.log(res);
        });
    },

    documentosPendientes() {
      let app = this;
      if (typeof app.documentosAlumno !== "undefined") {
        app.docsPend = 0;
        for (const item in app.documentosAlumno) {
          if (app.documentosAlumno[item].validar == 0) app.docsPend++;
        }
      }
    },

    async documentosRequeridos(alumno) {
      //let that = this;
      await this.$API
        .get({
          url: "documentos/requeridos/" + alumno,
          data: {},
        })
        .then((res) => {
          this.waiting = false;
          this.documentosAlumno = res;
          this.documentosPendientes();
        });
    },
    async logout() {
      let that = this;
      await this.$API
        .get({
          url: "alumno/logout",
          data: {},
        })
        .then(() => {
          setTimeout(() => {
            that.$store.dispatch("token", "");
            that.$store.dispatch("user", {});
            that.$router.replace({ name: "Login" });
          }, 1000);
        });
    },
    menuAction(route, validate) {
      if (
        route &&
        (validate == false || (validate == true && this.user.borrado !== "1"))
      ) {
        if (route == "Logout") {
          this.logout();
        } else if (route == "Verifier") {
          this.$store.dispatch("omitirValidacion", false);
          this.sendvalidation = true;
        } else {
          console.log(route);
          this.$router.push({
            name: route,
          });
        }
      }
    },
    async testPrueba() {
      await this.$API
        .get({
          url: "pyr-test/select",
          data: {},
        })
        .then((res) => {
          console.log(res);
          this.panels[4].data = res;
        });
    },
    async planDeEstudioGet() {
      await this.$API
        .get({
          url: "plan-de-estudio/index",
          data: {},
        })
        .then((res) => {
          this.panels[2].data = res;
        });
    },
    async mesaDeExamen() {
      await this.$API
        .get({
          url: "examen/mesas",
          data: {},
        })
        .then((res) => {
          this.panels[1].data = res;
        });
    },
    async mesaDeMateria() {
      await this.$API
        .get({
          url: "materia/mesas",
          data: {},
        })
        .then((res) => {
          this.panels[0].data = res;
        });
    },
    async tuPagos() {
      await this.$API
        .get({
          url: "alumno/pagos",
          data: {},
        })
        .then((res) => {
          this.panels[3].data = res;
        });
    },

    async inscripcionMesaExamen(examen, mesa) {
      await this.$API
        .post({
          url: "examen/mesas-inscripcion",
          data: {
            materia_id: examen,
            examenMesa_id: mesa,
          },
        })
        .then(() => {
          this.mesaDeExamen();
        });
    },
    async cancelarInscripcionMesaExamen(id) {
      await this.$API
        .post({
          url: "examen/cancelar-inscripcion",
          data: {
            id: id,
          },
        })
        .then(() => {
          this.mesaDeExamen();
        });
    },

    async inscripcionMesaMateria(examen, mesa) {
      await this.$API
        .post({
          url: "materia/mesas-inscripcion",
          data: {
            materia_id: examen,
            examenMesa_id: mesa,
          },
        })
        .then(() => {
          this.mesaDeMateria();
        });
    },
    async cancelarInscripcionMesaMateria(id) {
      await this.$API
        .post({
          url: "materia/cancelar-inscripcion",
          data: {
            id: id,
          },
        })
        .then(() => {
          this.mesaDeMateria();
        });
    },
    async MateriasFaltan() {
      await this.$API
        .post({
          url: "examenes/v2/showCursoIea",
          data: {
            alumno: this.user.IDStB,
          },
        })
        .then((res) => {
          let cursos = res.data;
          let materias;
          cursos.forEach((planestudio) => {
            console.log(planestudio.plan_de_estudio_v2.length)
            if (planestudio.plan_de_estudio_v2.length > 0) {
              materias  = planestudio.plan_de_estudio_v2.filter(
                (materia) => (materia.aprobada == false || materia.optativaAprobada == false)
              );
              if(materias.length > 0){
                this.materiaFaltantes = materias.reduce(
                (acc, el) => ({
                  ...acc,
                  [el.catedra]: el,
                }),{}
              );
              }
            }
          });
           console.log(this.materiaFaltantes);
        
        });
    },
    linkVideo(link) {
      this.$router.push({
        name: "MateriaCodigoClaseVideoAuth",
        params: {
          catedra: link.catedra_uuid,
          planestudio: link.planEstudio,
        },
      });
    },
    linkTest(test) {
      this.$router.push({
        name: "examen",
        params: {
          test: test.test_id,
          examen: test.id,
        },
      });
    },

    linkPrueba(idPrueba) {
      this.$router.push({
        name: "examen",
        params: {
          test: idPrueba,
        },
      });
    },
  },
};
</script>
